export default __webpack_public_path__ + "static/media/Video_6.749583e2.mp4";